var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroesseViereck03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Groesse-Viereck-03__Icn/40px/Groesse-Viereck-03",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Groesse-Viereck-03__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Groesse-Viereck-03__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35,9 L35,31 L5,31 L5,9 L35,9 Z M33,11 L7,11 L7,29 L33,29 L33,11 Z",
    id: ".._.._src_svg_Icn_40px_Groesse-Viereck-03__Rectangle-Copy"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroesseViereck03);
export default __webpack_public_path__ + "static/media/Groesse-Viereck-03.765b8416fb5edad983a1cdf7d9263d95.svg";
export { ForwardRef as ReactComponent };